<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">Nuevo Proveedor</h5>
              <div class="form-desc">
                Adición de un proveedor para compra de productos o servicios
              </div>
              <div class="row">
                <div class="col-sm-3 col-md-2">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }"
                      >Código</label
                    >
                    <input
                      v-model="current.codigo"
                      class="form-control"
                      placeholder="Código"
                      readonly="readonly"
                      type="text"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.codigo &&
                          current.errors.codigo.length > 0,
                      }"
                    />
                    <small
                      v-if="current.errors && current.errors.codigo"
                      class="form-text text-danger"
                      >{{ current.errors.codigo[0] }}</small
                    >
                  </div>
                </div>
                <div class="col-sm-9 col-md-10">
                  <div class="form-group">
                    <label
                      v-bind:class="{
                        'text-danger':
                          current.errors.nombre &&
                          current.errors.nombre.length > 0,
                      }"
                      >Nombre</label
                    >
                    <input
                      v-model="current.nombre"
                      class="form-control"
                      placeholder="Nombre"
                      autofocus="autofocus"
                      v-bind:class="{
                        'is-invalid':
                          current.errors.nombre &&
                          current.errors.nombre.length > 0,
                      }"
                      type="text"
                    />
                    <small
                      v-if="current.errors && current.errors.nombre"
                      class="form-text text-danger"
                      >{{ current.errors.nombre[0] }}</small
                    >
                  </div>
                </div>
              </div>

              <nav>
                <div class="nav nav-tabs" id="nav-tab" role="tablist">
                  <a
                    class="nav-item nav-link active"
                    id="nav-home-tab"
                    data-toggle="tab"
                    href="#nav-home"
                    role="tab"
                    aria-controls="nav-home"
                    aria-selected="true"
                    >Información General</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="direccion-tab"
                    data-toggle="tab"
                    href="#asignados"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Productos Asignados</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="direccion-tab"
                    data-toggle="tab"
                    href="#direccion"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Dirección</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="contables-tab"
                    data-toggle="tab"
                    href="#contables"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Datos Contables</a
                  >
                  <a
                    class="nav-item nav-link"
                    id="finanzas-tab"
                    data-toggle="tab"
                    href="#finanzas"
                    role="tab"
                    aria-controls="nav-profile"
                    aria-selected="false"
                    >Finanzas</a
                  >
                </div>
              </nav>
              <div class="tab-content element-box" id="nav-tabContent">
                <div
                  class="tab-pane fade show active"
                  id="nav-home"
                  role="tabpanel"
                  aria-labelledby="nav-home-tab"
                >
                  <div class="row">
                    <div class="col-md-5">
                      <div class="form-group">
                        <label for>Teléfono 1</label>
                        <input
                          v-model="current.telefono1"
                          class="form-control"
                          placeholder="Teléfono 1"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono 2</label>
                        <input
                          v-model="current.telefono2"
                          class="form-control"
                          placeholder="Teléfono 2"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Teléfono Móvil</label>
                        <input
                          v-model="current.telefono_movil"
                          class="form-control"
                          placeholder="Teléfono Móvil"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>FAX</label>
                        <input
                          v-model="current.fax"
                          class="form-control"
                          placeholder="FAX"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Email</label>
                        <input
                          v-model="current.email"
                          class="form-control"
                          placeholder="Email"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-2">
                      <div class="form-group">
                        <label for>Persona Contacto</label>
                        <input
                          v-model="current.nombre_contacto"
                          class="form-control"
                          placeholder="Persona Contacto"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>NIT</label>
                        <input
                          v-model="current.nit"
                          class="form-control"
                          placeholder="NIT"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>DPI</label>
                        <input
                          v-model="current.dpi"
                          class="form-control"
                          placeholder="DPI"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Web Site</label>
                        <input
                          v-model="current.web_site"
                          class="form-control"
                          placeholder="Web Site"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-4">
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            checked
                            class="form-check-input"
                            name="optionsRadios"
                            v-model="current.activo"
                            type="radio"
                            value="true"
                          />Activo
                        </label>
                      </div>
                      <div class="form-check">
                        <label class="form-check-label">
                          <input
                            class="form-check-input"
                            v-model="current.activo"
                            name="optionsRadios"
                            type="radio"
                            value="false"
                          />Inactivo
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="direccion"
                  role="tabpanel"
                  aria-labelledby="direccion-tab"
                >
                  <div class="row">
                    <div class="col-md-5">
                      <h6>Dirección Comercial</h6>
                      <br />
                      <div class="form-group">
                        <label>Dirección</label>
                        <textarea
                          v-model="current.fiscal_direccion"
                          class="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label for>Calle</label>
                        <input
                          v-model="current.fiscal_calle"
                          class="form-control"
                          placeholder="Calle"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Colonia</label>
                        <input
                          v-model="current.fiscal_colonia"
                          class="form-control"
                          placeholder="Colonia"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Ciudad</label>
                        <input
                          v-model="current.fiscal_ciudad"
                          class="form-control"
                          placeholder="Ciudad"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Pais</label>
                        <input
                          v-model="current.fiscal_pais"
                          class="form-control"
                          placeholder="Pais"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Estado</label>
                        <input
                          v-model="current.fiscal_estado"
                          class="form-control"
                          placeholder="Estado"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-md-5 offset-md-1">
                      <h6>Dirección Fiscal</h6>
                      <br />
                      <div class="form-group">
                        <label>Dirección</label>
                        <textarea
                          v-model="current.comercial_direccion"
                          class="form-control"
                          rows="3"
                        ></textarea>
                      </div>
                      <div class="form-group">
                        <label for>Calle</label>
                        <input
                          v-model="current.comercial_calle"
                          class="form-control"
                          placeholder="Calle"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Colonia</label>
                        <input
                          v-model="current.comercial_colonia"
                          class="form-control"
                          placeholder="Colonia"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Ciudad</label>
                        <input
                          v-model="current.comercial_ciudad"
                          class="form-control"
                          placeholder="Ciudad"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Pais</label>
                        <input
                          v-model="current.comercial_pais"
                          class="form-control"
                          placeholder="Pais"
                          type="text"
                        />
                      </div>
                      <div class="form-group">
                        <label for>Estado</label>
                        <input
                          v-model="current.comercial_estado"
                          class="form-control"
                          placeholder="Estado"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="asignados"
                  role="tabpanel"
                  aria-labelledby="direccion-tab"
                >
                  <div class="row">
                    <div class="col-11">
                      <ProductoSelectComponent :current="current" />
                    </div>
                    <div class="col-1">
                      <br />
                      <button
                        class="btn btn-success"
                        @click="asignarProductoProveedor(current)"
                      >
                        Asignar Producto
                      </button>
                    </div>
                    <ProductoProveedorTable
                      :current="current"
                      @refreshProductoProveedor="
                        refreshProductoProveedor(current.id)
                      "
                      :data="data"
                    />
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="contables"
                  role="tabpanel"
                  aria-labelledby="contables-tab"
                >
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_debe_obj'"
                          :current="current"
                          :label="'Cuenta Contable Debe'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_haber_obj'"
                          :current="current"
                          :label="'Cuenta Contable Haber'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>

                    <div class="col-sm-12">
                      <div class="form-group">
                        <label
                          v-bind:class="{
                            'text-danger':
                              current.errors && current.errors.length > 0,
                          }"
                        >
                        </label>
                        <CuentaContableSelectComponent
                          :propname="'cuenta_contable_gasto_obj'"
                          :current="current"
                          :label="'Cuenta Contable Gasto'"
                        />
                        <small
                          v-if="current.errors"
                          class="form-text text-danger"
                          >{{ current.errors.detail }}</small
                        >
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="tab-pane fade"
                  id="finanzas"
                  role="tabpanel"
                  aria-labelledby="finanzas-tab"
                >
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for>Banco</label>
                        <input
                          v-model="current.banco"
                          class="form-control"
                          placeholder="Banco"
                          type="text"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label for>Cuenta Bancaria para Depósitos</label>
                        <input
                          v-model="current.cuenta_bancaria"
                          class="form-control"
                          placeholder="Cuenta Bancaria para Depósitos"
                          type="text"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-buttons-w">
                <button class="btn btn-primary" @click="guardar(current)">
                  Guardar
                </button>
                <router-link
                  class="btn btn-default"
                  :to="{ name: 'cat-proveedores', params: {} }"
                >
                  <i class="fa fa-back"></i>
                  Volver al Listado
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from "lodash";
import ProveedorService from "@/services/catalogos/ProveedorService";
import Notifications from "@/notifications/notifications";
import CuentaContableSelectComponent from "@/components/commons/CuentaContableSelectComponent";
import ProductoSelectComponent from "@/components/commons/ProductoSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import ProductoProveedorTable from "@/components/cat/proveedores/ProductoProveedorTable";

export default {
  components: {
    CuentaContableSelectComponent,
    ProductoSelectComponent,
    ProductoProveedorTable,
  },
  data() {
    return {
      data: [],
      current: {
        producto: "",
        errors: {},
      },
    };
  },

  computed: {},
  mounted() {
    if (this.$route.params.id) {
      ProveedorService.getById(this.$route.params.id).then((response) => {
        this.current = response.data;
        this.current.errors = [];
        this.refreshProductoProveedor(this.$route.params.id);
      });
    }
  },

  methods: {
    refreshProductoProveedor(proveedor_id) {
      let self = this;

      DynamicService.fetch("cat", "producto-proveedor", {
        proveedor: proveedor_id,
        quitar_paginacion: true,
      }).then((response) => {
        self.data = response.data;
      });
    },
    asignarProductoProveedor(current) {
      let self = this;
      if (!current.producto) {
        alert("Error, Producto no puede ser Nulo");
        return;
      }
      var parametros = {
        proveedor: current.id,
        producto: current.producto.sku,
      };
      DynamicService.save("cat", "producto-proveedor", parametros)
        .then((response) => {
          Notifications.alert.success(
            "Asignar Producto a Proveedor",
            "Realizado Correctamente"
          );
          current.producto = "";
          self.refreshProductoProveedor(this.$route.params.id);
        })
        .catch((errors) => {
          Notifications.alert.error("Error", response.data.detail);
        });
    },
    DeleteProductoProveedor(producto_id) {
      let self = this;
      var parametros = {
        proveedor: this.current.id,
        producto: producto_id.sku,
      };
      DynamicService.delete("cat", "producto-proveedor", parametros)
        .then((response) => {
          Notifications.alert.success("Eliminado Correctamente");
          self.refreshProductoProveedor(this.$route.params.id);
        })
        .catch((errors) => {
          Notifications.alert.error("Error", response.data.detail);
        });
    },
    guardar(current) {
      let self = this;
      var current = Object.assign({}, this.current);
      delete current.image;
      if (current.codigo == null) {
        delete current.codigo;
      }
      let value = current.cuenta_contable_debe_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_debe = current.cuenta_contable_debe_obj.id;
      }
      value = current.cuenta_contable_haber_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_haber = current.cuenta_contable_haber_obj.id;
      }
      value = current.cuenta_contable_gasto_obj;
      if (value && typeof value === "object" && value.constructor === Object) {
        current.cuenta_contable_gasto = current.cuenta_contable_gasto_obj.id;
      }
      ProveedorService.save(current)
        .then((res) => {
          self.current = res.data;
          self.current.errors = {};
          Notifications.alert.success(
            "Proveedor",
            "Se ha guardado la Información."
          );
          self.$router.push({
            name: "cat-proveedores-editar",
            params: { id: self.current.codigo },
          });
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
            self.current.errors = error.response.data;
          }
        });
    },
    showModal(e) {
      e.preventDefault();
    },
  },
};
</script>
